import 'echarts/lib/chart/bar';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { merge } from 'lodash';

import ChartService from './ChartService';
import { splitWordsToLines, trimDotEnd, isTextWithinLimit, generateColors, splitSentanceToWords } from './chartCommon';

export default class ChartHorizontalBarService extends ChartService {

  buildChartData(visualization, isEditMode) {
    let visualizationData = visualization.stacked ? visualization.data : [visualization.data];
    let colors = generateColors(visualizationData.length);
    const formatter = (params) => {
      const count = params.data.value;
      let category = visualizationData[0][params.dataIndex].category;
      if (category) {
        category = ' (' + category + ')';
      }

      const marker = `<dt style="width:10px;height:10px;display:inline-block;margin-right:5px;">
                      <svg viewBox="0 0 12 12"><path fill="${params.color}" d="M0 0h12v12H0z"></path></svg>
                    </dt>`;
      return params.name + '<br>'
        + marker + count + (category || '');
    };

    const options = {

      grid: {
        bottom: '2%',
        containLabel: true,
        left: '10px',
        right: '5%',
        top: '10%'
      },

      series: visualizationData.map((data, dataInd) => ({
        barMaxWidth: 40,
        barGap: '0',
        barCategoryGap: '5',
        data: data.map((item, ind) => {
          const defaultColor = item.color || colors[dataInd];
          const uncheckedColor = 'rgb(216,216,216)';

          const color = isEditMode && item.unchecked ? uncheckedColor : defaultColor;

          return {
            data: item,
            dataIndex: ind,
            value: item[visualization.value_field],
            defaultColor,
            itemStyle: {
              normal: { color },
              emphasis: { color, opacity: 1 },
            }
          };
        }).reverse(),
        itemStyle: {
          barBorderRadius: [0, 4, 4, 0],
          opacity: 0.8,
        },
        name: visualization.name_field,
        type: 'bar',
        stack: visualization.stacked ? 'stack' : undefined,
        z: 0
      })),

      yAxis: {
        axisLabel: {
          color: '#000',
          formatter: (value) => {
            const splitted = splitWordsToLines(splitSentanceToWords(value).map((word) => ({ word })), isTextWithinLimit(253), 2);
            if (splitted[1]) {
              splitted[1] = trimDotEnd(splitted[1], isTextWithinLimit(253));
            }
            return splitted.map((f) => f.sentance).join('\n');
          },
          fontSize: 11,
        },
        axisLine: {
          lineStyle: {
            color: '#767676',
          },
        },
        axisTick: {
          alignWithLabel: true,
          lineStyle: {
            color: '#767676',
          }
        },
        data: (visualizationData[0] || []).map((item) => item[visualization.name_field]).reverse(),
        z: 1,
      },

      xAxis: {
        axisLabel: {
          fontSize: 13,
          rotate: 0,
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        name: visualization.value_field,
        nameLocation: 'center',
        nameGap: 75,
        nameTextStyle: {
          fontWeight: 'bold',
          fontSize: 13,
        },
      },

      tooltip: {
        formatter(params) {
          return (visualization.formatter || formatter)(
            {
              ...params,
              color: params.data.defaultColor,
              dataIndex: visualizationData[0].length - 1 - params.dataIndex
            });
        }
      }
    };

    return merge(this.defaultChartOptions, options);
  }

}
